import i18n from '@/lib/language'
// 获取字体类型
function getFontFamily (type) {
  let fontFamily = ''
  switch (type) {
    case 1 :
      fontFamily = 'Arial'
      break
    case 2 :
      fontFamily = 'Courier'
      break
    case 3 :
      fontFamily = 'Georgia'
      break
    case 4 :
      fontFamily = 'Helvetica'
      break
    case 5 :
      fontFamily = 'MicroSoft YaHei'
      break
    case 6 :
      fontFamily = 'PingFang SC'
      break
    case 7 :
      fontFamily = 'Tahoma'
      break
    case 8 :
      fontFamily = 'Verdana'
      break
    case 9 :
      fontFamily = '宋体'
      break
    case 10 :
      fontFamily = '黑体'
      break
    default:
      fontFamily = '宋体'
  }
  return fontFamily
}

// 获取对齐方式类型
function getAlignType (type) {
  let align = ''
  if (type === 1) {
    align = 'left'
  } else if (type === 2) {
    align = 'center'
  } else {
    align = 'right'
  }
  return align
}

// form表单生成类型
function formElemType (item) {
  let html = ''
  switch (item.fieldtype) {
    case 'phone':
    case 'email':
    case 'text' :
    case 'number':
      html = `<input type="text" value="${item.defaultvalue}" placeholder="${item.placeholder}"`
      break
    case 'radio':
      item.options.forEach(key => {
        if (key.isshow) {
          html += ` <label for="${key.id}" class="f-r-c-label">
                    <input type="radio" id="${key.id}" class="f-chekbox-radio" value="${key.id} checked="${item.defaultvalue === key.id ? 'checked' : false} />
                    ${key.showname || key.name}
                  </label>
                `
        }
      })
      break
    case 'checkbox':
      item.options.forEach(key => {
        if (key.isshow) {
          html += ` <label for="${key.id}" class="f-r-c-label">
          <input type="checkbox" id="${key.id}" class="f-chekbox-radio" value="${key.id}" checked="${item.defaultvalue.indexOf(key.id) > -1 ? 'checked' : false}"/>
          ${key.showname || key.name}
        </label>
      `
        }
      })
      break
    case 'select' :
      let options = ''
      item.options.forEach(key => {
        if (key.isshow) {
          options += `    <option value="${key.id} select="${item.defaultvalue === key.id ? 'selected' : false}">${key.showname || key.name}</option>"
          `
        }
      })
      html = `<select>
                  ${options}
                  </select>
                `
      break
    case 'select_tree' :
      html = `<div class="select-tree"></div>`
      break
    case 'file' :
      html = `<div class="file"></div>`
      break
    case 'area' :
      html = `<div class="area"></div>`
      break
    case 'editor' :
      html = `<div class="editor"></div>`
      break
    case 'datetime' :
      html = `<div class="datetime"></div>`
      break
  }
  return html
}

// viewjson转换成样式
export function convertStyle (sytlejson) {
  let str = ''
  sytlejson.forEach(item => {
    for (let k in item) {
      if (k === 'listStyle') {
        if (item[k] === 2) {
          str += '.f-item-row { padding-left: 40px;}.f-item-label { float: none; margin-left: 0; text-align: left; } .f-item-row .f-item-cell { float:none;}'
        } else {
          str += '.f-item-row { padding-left: 180px;}.f-item-label { float: left; margin-left: -180px; } .f-item-row .f-item-cell { float:left;}'
        }
      } else if (k === 'inputAndSelect') {
        str += `.f-select, .f-input-text {width:${item[k].width}${item[k].unit === 1 ? 'px' : '%'}; height: ${item[k].height}px;
          padding: 0 ${item[k].paddingLeftAndRight}px;box-sizing: border-box;background:${item[k].backgroundColor};border-radius: ${item[k].borderRadius}px;
          ${item[k].borderStyle === 1 ? 'border:1px solid #d6d6d6;' : 'border-bottom: 1px solid #d6d6d6;border-left:none; border-right:none;border-top:none;'}
        } .f-item-row input, .f-item-row input[disabled], .f-item-row select, .f-item-row select[disabled]{background:${item[k].backgroundColor};} .f-select:hover, .f-input-text:hover{border-color:${item[k].hoverBorderColor};}`
      } else if (k === 'font') {
        str += `.f-item-row, .f-item-row label, .f-input-text, .f-select{font-size: ${item[k].contentSize}px; color:${item[k].contentColor}; font-family: "${getFontFamily(item[k].fontFamily)}"; }`
      } else if (k === 'button') {
        str += `.f-item-row .sub-btn, .f-item-row .sub-btn[disabled]{ font-size: ${item[k].fontSize}px; background: ${item[k].buttonColor}; color: ${item[k].fontColor};}
        .f-item-row-btn .f-item-cell {text-align: ${getAlignType(item[k].float)};}
        `
      }
    }
  })
  return str
}

// 头部插入css样式，
export function appendStyle (css, id) {
  let head = document.getElementsByTagName('head')[0]
  let style = document.createElement('style')
  style.type = 'text/css'
  style.id = id
  // document.querySelector('style[id="view-css"]').remove()
  const ele = document.getElementById(id)
  if (ele) {
    head.removeChild(ele)
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css
  } else {
    style.appendChild(document.createTextNode(css))
  }
  head.appendChild(style)
}

// 根据表单数据转换成html
export function convertHtml (formDefaultDatas, deployDatas) {
  let strHtml = ''
  let validHtml = ''
  formDefaultDatas.forEach(item => {
    strHtml += ` <div class="ui-form-item f-item-row" data-key="${item.fieldkey}" data-type="${item.fieldtype}">
                 <label class="f-item-label ui-label">
                    ${item.isneeded ? '<span class="ui-form-required need-tip">*</span>' : ''}
                    ${item.label}：
                  </label>
                  <div class="f-item-cell">
                    ${formElemType(item)}
                  </div>
                </div>
              `
  })

  validHtml = `<div class="ui-form-item f-item-row">
                <label class="f-item-label ui-label">${i18n.t('message["1433"]')}</label>
                <div class="f-item-cell">
                  <div class="valid-code-box"></div>
                </div>
              </div>`
  strHtml += `${deployDatas.config && deployDatas.config.need_captcha ? validHtml : ''}
              <div class="f-item-row f-item-row-btn">
                <div class="f-item-cell">
                  <button type="submit" class="sub-btn">
                    ${deployDatas.config && deployDatas.config.submit_text}
                  </button>
                </div>
              </div>`
  strHtml = `         <form data-widget="validator" id="ui-form" class="ui-form universal-form" data-trigger-type="change" data-action="/submitto.php" data-projectid="MTAwMDAwXzEwMDAwMA==">
              ${strHtml}
            </form>`
  return strHtml
}

export function getH (ele, num) {
  // console.log(window.innerHeight, document.documentElement.clientHeight)
  ele.style.height = (window.innerHeight || document.documentElement.clientHeight) - num + 'px'
  window.addEventListener('resize', function () {
    ele.style.height = (window.innerHeight || document.documentElement.clientHeight) - num + 'px'
  })
}
